<template>
  <div>
    <p class="detail-label">{{ label }}</p>
    <slot>
      <p :class="prominent ? 'detail-value-prominent' : 'detail-value'">{{ value }}</p>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'DetailField',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    prominent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
